import { render, staticRenderFns } from "./rule.vue?vue&type=template&id=2ff6e9b7&scoped=true&"
import script from "./rule.vue?vue&type=script&lang=js&"
export * from "./rule.vue?vue&type=script&lang=js&"
import style0 from "./rule.vue?vue&type=style&index=0&lang=css&"
import style1 from "./rule.vue?vue&type=style&index=1&id=2ff6e9b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff6e9b7",
  null
  
)

export default component.exports